
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"36","viewBox":"0 0 100 62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".168","width":"100","height":"61.832","rx":"4","fill":"#ECC3FF"}}),_c('rect',{attrs:{"x":"8.13","y":"17.253","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.13","y":"25.389","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.13","y":"33.525","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.13","y":"41.661","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.13","y":"49.796","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.13","y":"8.153","width":"39.024","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('ellipse',{attrs:{"cx":"11.441","cy":"54.361","rx":"6.098","ry":"6.102","fill":"#7B01B5"}}),_c('rect',{attrs:{"x":"4.637","y":"5.863","width":"31.707","height":"40.679","rx":"4","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M25.838 25.363a.5.5 0 010 .866l-7.646 4.418a.5.5 0 01-.75-.433v-8.836a.5.5 0 01.75-.433l7.646 4.418z","fill":"#fff"}})])
          )
        }
      }
    